// Library Methods
import axios from "axios";

// Utils
import { config, webServiceUrl } from "src/utils/services/servicesHelper";

const getIceEndpoint = async (token: string) => {
  try {
    const res = await axios.get(
      `${webServiceUrl}/web-rtc/ice-endpoint`,
      config(token)
    );
    return res?.data?.data;
  } catch (error) {
    throw error;
  }
};

const getIceServers = async (url: string, credentials: string) => {
  const data = { format: "urls" };
  const base64Credentials = btoa(credentials);
  const headers = {
    Authorization: `Basic ${base64Credentials}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.put(url, data, { headers: headers });
    if (!response?.data?.v?.iceServers) throw new Error("invalid data");

    const servers: RTCIceServer[] = Array.isArray(response.data.v.iceServers)
      ? response.data.v.iceServers
      : [response.data.v.iceServers];

    // Only return urls with TCP on port 443 so firewalls that block UDP or non-443 ports
    // don't silently prevent the connection.
    const tcp443 = servers.flatMap((server) => {
      const urls = Array.isArray(server.urls) ? server.urls : [server.urls];
      const filtered = urls.filter(
        (url) =>
          typeof url === "string" &&
          url.includes(":443") &&
          url.includes("transport=tcp")
      );
      return filtered.length > 0 ? [{ ...server, urls: filtered }] : [];
    });

    return tcp443.length > 0 ? tcp443 : servers;
  } catch (error) {
    throw error;
  }
};

export { getIceEndpoint, getIceServers };
